import { Router } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import Boot from './boot';
import ErrorBoundary from './components/error-boundary';
import { setAgGridLicense } from './config/ag-grid-license';
import Routing from './router/routing';
import MUITheme from './theme';
import history from './utils/history';

setAgGridLicense();

function App() {
  return (
    <ErrorBoundary>
      <Router history={history}>
        <MuiThemeProvider theme={MUITheme}>
          <Boot>
            <Routing />
          </Boot>
        </MuiThemeProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
